import React from 'react'
import { connect } from 'react-redux';
import EditModal from "../../EditSite/EditModal";
import SiteHistoryModal from "./SiteHistoryModal";
import { Icon, TooltipHost } from '@fluentui/react';
import { attentionMessages } from '../../../GlobalConst/attentionMessages';
import TempAdminsModal from './TempAdminsModal';
import { PermissionRole } from "../../../GlobalConst/globalEnums";


class MainView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showEditModal: false,
            showHistoryModal: false,
            showTempAdminsModal: false
        }
    }

    showEditModal = () => {
        this.setState({showEditModal: true})
    }

    onCloseEditModal = () => {
        this.setState({showEditModal: false})
    }

    showHistoryModal = () => {
        this.setState({showHistoryModal: true})
    }

    onCloseHistoryModal = () => {
        this.setState({showHistoryModal: false})
    }

    showTempAdminsModal = () => {
        this.setState({showTempAdminsModal: true})
    }

    onCloseTempAdminsModal = () => {
        this.setState({showTempAdminsModal: false})
    }

    render() {
        var attentionIcon = null;
        var attentions = this.props.editedSite.attentions.filter(a => a.isValid);
        if(attentions.length) {
            const attentionText = attentions.map((a, i) => <span key={i}>{attentionMessages[a.type]}<br/></span>);
            attentionIcon = <TooltipHost content={attentionText}>
                                <Icon iconName='important' style={iconStyles} />
                            </TooltipHost>
        }

        return (
            <div style={iconContainerStyles}>
                <div>
                    <Icon style={editIconStyles} onClick={this.showEditModal} iconName="edit" />
                    <EditModal 
                        editedSite={this.props.editedSite} 
                        isModalOpened={this.state.showEditModal} 
                        onCloseModal={this.onCloseEditModal} 
                        callBack={this.props.callBack}
                    />
                </div>
                <div>
                    <Icon style={iconStyles} onClick={this.showHistoryModal} iconName="diagnostic" />   
                    <SiteHistoryModal 
                        site={this.props.editedSite} 
                        isModalOpened={this.state.showHistoryModal} 
                        onCloseModal={this.onCloseHistoryModal} 
                    />
                </div>
                {
                    (this.props.role === PermissionRole.administrator || this.props.role === PermissionRole.owner) && this.props.editedSite.url && 
                    <div>
                        <Icon style={iconStyles} onClick={this.showTempAdminsModal} iconName="addFriend" />   
                        <TempAdminsModal 
                            site={this.props.editedSite} 
                            isModalOpened={this.state.showTempAdminsModal}
                            onCloseModal={this.onCloseTempAdminsModal}
                        />
                    </div>
                }
                <div>
                    {attentionIcon}
                </div>
            </div>
        );
    }
}

const iconContainerStyles = {
    display: 'flex'
}

const editIconStyles = {
    cursor: 'pointer',
    margin: '1px 5px',
    fontSize: '14px',
    fontWeight: '600'
}

const iconStyles = {
    cursor: 'pointer',
    margin: '0 5px',
    fontSize: '16px',
    fontWeight: '600'
}

const mapStateToProps = state => ({
    role: state.user.role
})

export default connect(mapStateToProps, null)(MainView)


// WEBPACK FOOTER //
// ./src/components/Administration/SiteDetails/MainView.js